import { ButtonColors } from 'types';
import { Flex } from 'components/flex';
import { Row, Col } from 'components/grid';
import { InputField } from 'components/fields';
import { Dialog, DialogType } from 'components/dialog';
import { Button, ButtonWithRef } from 'components/button';

import { RefundDialogProps } from './types';

export const RefundExchangeDialog = ({
  disabled,
  onConfirm,
  isExchange,
  hideManagerPin,
}: RefundDialogProps) => (
  <Dialog
    title={`Accept ${isExchange ? 'Exchange' : 'Refund'}`}
    trigger={
      <ButtonWithRef
        disabled={disabled}
        text={`Confirm ${isExchange ? 'Exchange' : 'Refund'}`}
      />
    }
  >
    {(close, _, ButtonWrap) => (
      <Flex column gap={8} fullWidth>
        <div>
          Are you sure you want to make a {isExchange ? 'exchange' : 'refund'}{' '}
          on this order? This action cannot be cancelled
        </div>

        {!hideManagerPin && (
          <Row>
            <Col>
              <InputField
                number
                autofill="off"
                hidePasswordEye
                type="password"
                label="Manager PIN"
                name="approvalPassword"
                placeholder="Manager PIN"
                autoComplete="new-password"
              />
            </Col>
          </Row>
        )}

        <ButtonWrap type={DialogType.Plain}>
          <Button
            text="Cancel"
            onClick={close}
            colorType={ButtonColors.LightBlue}
          />
          <Button
            text="Accept"
            colorType={ButtonColors.LightGreen}
            onClick={() => {
              onConfirm();
              close();
            }}
          />
        </ButtonWrap>
      </Flex>
    )}
  </Dialog>
);
